import { Title } from '@/components/Typography';

export const TitleElement = ({
  text,
  tag,
  dataTest,
}: {
  text: string;
  tag?: string;
  dataTest?: string;
}) => {
  return (
    <Title tag={tag || 'div'} type="md" data-test={dataTest} className="banner-2-title">
      {text}
    </Title>
  );
};
